export const PAYME_HANDLE_MAX_LENGTH = 50;
export const PAYME_HANDLE_PATTERN = /^[a-zA-Z0-9_-]+$/;

export const isValidPayMeHandle = (value: string): boolean =>
  PAYME_HANDLE_PATTERN.test(value.trim());

export const sanitizeSuggestedHandle = (name: string): string =>
  name.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9_-]/g, '');
